"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.promise");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("formik"),
    r = e(require("immer")),
    n = e(require("react")),
    i = require("react-albus");

function o() {
  return (o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function u(e) {
  return e.reduce(function (e, t) {
    return e[t.id] = t.initialValues, e;
  }, {});
}

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));
var a = n.createContext(null);

function s(e) {
  var i = e.step,
      o = e.Form,
      u = void 0 === o ? t.Form : o,
      a = e.FormWrapper,
      s = e.steps,
      c = e.wizard,
      l = e.formikProps,
      m = e.onSubmit,
      f = e.setStatus,
      d = e.status,
      p = e.values,
      v = e.setValues,
      S = n.useMemo(function () {
    return {
      canGoBack: s[0] !== i.id,
      currentStep: i.id,
      isLastStep: s[s.length - 1] === i.id
    };
  }, [s, i]),
      b = n.useCallback(function (e) {
    try {
      var t,
          n = function n() {
        f(t);
      };

      f(void 0);

      var o = function (n, o) {
        try {
          var u = function () {
            var n = function () {
              if (S.isLastStep) {
                var n = r(p, function (t) {
                  t[S.currentStep] = e;
                });
                return Promise.resolve(m(n)).then(function (e) {
                  t = e, v(n);
                });
              }

              var o = function o(n) {
                t = n, v(function (t) {
                  return r(t, function (t) {
                    t[S.currentStep] = e;
                  });
                }), setImmediate(c.next);
              };

              return i.onAction ? Promise.resolve(i.onAction(e, p)).then(o) : o(void 0);
            }();

            if (n && n.then) return n.then(function () {});
          }();
        } catch (e) {
          return o(e);
        }

        return u && u.then ? u.then(void 0, o) : u;
      }(0, function (e) {
        t = e;
      });

      return Promise.resolve(o && o.then ? o.then(n) : n());
    } catch (e) {
      return Promise.reject(e);
    }
  }, [S.currentStep, S.isLastStep, m, f, v, i, p, c.next]);
  return n.createElement(t.Formik, Object.assign({}, l, {
    enableReinitialize: !0,
    initialValues: i.initialValues,
    validationSchema: i.validationSchema,
    validate: i.validate,
    onSubmit: b
  }), function (e) {
    return n.createElement(u, {
      onSubmit: e.handleSubmit
    }, n.createElement(a, Object.assign({}, S, {
      steps: s,
      wizard: c,
      actionLabel: i.actionLabel,
      isSubmitting: e.isSubmitting,
      goToPreviousStep: function goToPreviousStep() {
        f(void 0), i.keepValuesOnPrevious && v(function (t) {
          return r(t, function (t) {
            t[i.id] = e.values;
          });
        }), c.previous();
      },
      status: d,
      values: p,
      setStatus: f,
      setValues: v
    }), n.createElement(i.component)));
  });
}

function c(e) {
  var t = e.formikProps,
      r = e.albusProps,
      c = e.onSubmit,
      l = e.steps,
      m = e.Form,
      f = e.render,
      d = n.useState(void 0),
      p = d[0],
      v = d[1],
      S = n.useState(function () {
    return u(l);
  }),
      b = S[0],
      y = S[1];
  n.useEffect(function () {
    y(u(l)), v(void 0);
  }, [l]);
  var h = n.useMemo(function () {
    return l.map(function (e) {
      return e.id;
    });
  }, [l]);
  return n.createElement(i.Wizard, Object.assign({}, r), n.createElement(a.Provider, {
    value: {
      status: p,
      setStatus: v,
      values: b,
      setValues: y
    }
  }, n.createElement(i.Steps, null, l.map(function (e) {
    return n.createElement(i.Step, {
      key: e.id,
      id: e.id,
      render: function render(r) {
        return n.createElement(s, {
          wizard: r,
          formikProps: t,
          onSubmit: c,
          steps: h,
          status: p,
          values: b,
          setValues: y,
          setStatus: v,
          step: o({}, e, {
            initialValues: b[e.id] || {}
          }),
          Form: m,
          FormWrapper: f
        });
      }
    });
  }))));
}

exports.FormikWizard = c, exports["default"] = c, exports.useFormikWizard = function () {
  return n.useContext(a);
};